import { useState } from 'react';
import LinkSharingDialog from './LinkSharingDialog';
import selectLinkInputContent from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeHeader/options/ChallengeLinkSharing/selectLinkInputContent';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import { IosShare as ShareIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

type TaskLinkSharingProps = Omit<MenuItemProps, 'onClick' | 'children'>;

const TaskLinkSharing = (props: TaskLinkSharingProps) => {
  const [linkDialogOpen, setLinkDialogOpen] = useState(false);

  return (
    <>
      <MenuItem
        onClick={() => {
          selectLinkInputContent();
          setLinkDialogOpen(true);
        }}
        {...props}
      >
        <ListItemIcon>
          <ShareIcon />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="portfolio.challenge.options.link_sharing.label" />
        </ListItemText>
      </MenuItem>
      <LinkSharingDialog
        open={linkDialogOpen}
        onClose={() => setLinkDialogOpen(false)}
      />
    </>
  );
};

export default TaskLinkSharing;
